import template from "./template.html";
import config from "../config";

export default function (editor) {
  const { DomComponents, BlockManager } = editor;

  // Общие defaults для редактируемых text-узлов (вопрос/ответ).
  const editableText = {
    editable: true,
    selectable: true,
    hoverable: true,
    draggable: false,
    removable: false,
    copyable: false,
  };

  DomComponents.addType("landing-page-faq", {
    isComponent: (el: HTMLElement) => el.classList && el.classList.contains("landing-page-faq"),
    model: {
      defaults: {
        draggable: true,
        removable: true,
        selectable: true,
        hoverable: true,
        stylable: ["background-color"],
      },
    },
  });
  DomComponents.addType("landing-page-faq-item", {
    isComponent: (el: HTMLElement) => el.classList && el.classList.contains("landing-page-faq__item"),
    model: {
      defaults: {
        removable: true,
        selectable: true,
        copyable: true,
        hoverable: true,
      },
    },
  });
  // Текст вопроса и ответа — редактируемые text-компоненты (наследуют RTE).
  // Регистрируем явно, иначе вложенность в невыделяемые контейнеры мешает
  // двойному клику для входа в режим редактирования.
  DomComponents.addType("landing-page-faq-question", {
    extend: "text",
    isComponent: (el: HTMLElement) => el.classList && el.classList.contains("landing-page-faq__question"),
    model: {
      defaults: { ...editableText },
    },
  });
  DomComponents.addType("landing-page-faq-answer", {
    extend: "text",
    isComponent: (el: HTMLElement) => el.classList && el.classList.contains("landing-page-faq__answer-text"),
    model: {
      defaults: { ...editableText },
    },
  });

  BlockManager.add("landing-page-faq", {
    ...config,
    label: "FAQ (accordion)",
    content: template,
  });
}
